<template>
  <div class="h-full">
    <!-- {{formularios}} -->
    <ul class="overflow-x-auto h-container-items">
      <li
        class="flex justify-between p-3 pl-8"
        :class="{ 'border-0 border-b border-gray-300 border-solid': item !== 10 }"
        v-for="(item, key) in formularios"
        :key="key"
      >
        <!-- {{ item }} -->
        <div class="flex items-center">
          <div class="mr-1">
            <vs-radio v-model="keyForm" @click.stop :vs-value="`${item.formID}`"></vs-radio>
          </div>
          <div>
            <div><b>Formulario:</b> {{ item.activity }}</div>
            <div><b>Tipo de formulario:</b> {{ item.formType }}</div>
            <div><b>Grupo:</b> {{ item.groupName }}</div>
          </div>
        </div>

        <div class="flex flex-col justify-between items-end">
          <div>
            <vs-chip>
              <div class="h-2 w-2 rounded-full mr-1" :class="'bg-' + todoLabelColor(item.status)"></div>
              <span>{{ $t(`TRANSFERVIEW.${item.status}`) | capitalize }}</span>
            </vs-chip>
          </div>
          <div class="mr-3 text-sm">{{item.created_at | formateDate}}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import DateUtils from "@/helpers/DateUtils";
export default {
  filters: {
    formateDate(date) {
        return DateUtils.toDefaultDateTime(date, "DD MMM YYYY")
    }
  },
  data: () => ({
    listaFormularios: []
  }),
  computed: {
    formularios() {
      return this.$store.getters["transer/queriedTasks"];
    },
    keyForm: {
      get() {
        return this.$store.state.transer.keyForm;
      },
      set(value) {
        this.$store.commit("transer/GET_KEYS_FORMS", value);
      }
    },
    todoLabelColor() {
      return label => {
        return label === "Active" ? "success" : "danger";
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.h-container-items {
  height: calc(100% - 50px);
}
.border-gray-300 {
  border-color: #e2e8f0;
}
</style>
